module.exports = __webpack_public_path__ + "img/onlylead03.1b7f4403.png";